import { PayloadAction } from "@reduxjs/toolkit";
import api from "../../Axios/middleware";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import { IAPIResponse } from "../../interfaces/IAPIResponse";
import {
  failureForgetPassword,
  successForgetPassword,
} from "./ForgetPasswordSlicer";
import { IForgetPasswordMail } from "../../../Pages/ForgotPassword/IForgetPassword";
import {
  failureForgetPasswordMail,
  successForgetPasswordMail,
} from "./ForgetPasswordMailSlice";

// reset password - Update password with token, new password and confirm password
const ForgetPasswordApi = (action: PayloadAction<{ token: string; password: string; confirmPassword: string }>) => {
  return api.post("/parkingOwner/reset-password", {
    token: action.payload.token,
    password: action.payload.password,
    confirmPassword: action.payload.confirmPassword,
  });
};

export function* ForgetPasswordCall(
  action: PayloadAction<{ token: string; password: string; confirmPassword: string }>
) {
  try {
    const respons: AxiosResponse<IAPIResponse<null>> = yield call(
      ForgetPasswordApi,
      action
    );
    yield put(successForgetPassword(respons.data));
  } catch (error: any) {
    // Extract error message from various possible locations
    let errorMessage = 'Failed to reset password. Please try again.';
    
    if (error?.response?.data) {
      if (error.response.data.response?.error) {
        errorMessage = error.response.data.response.error;
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error;
      } else if (error.response.data.response?.message) {
        errorMessage = error.response.data.response.message;
      } else if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      }
    } else if (error?.message) {
      errorMessage = error.message;
    }
    
    const responseCode = error?.response?.data?.responseCode || 
                        error?.response?.status || 
                        400;
    
    yield put(failureForgetPassword({
      responseCode: responseCode,
      responseMessage: 'failed',
      response: { error: errorMessage }
    }));
  }
}

// forget password mail - Check email exists and is active
const ForgetPasswordMailApi = (action: PayloadAction<IForgetPasswordMail>) => {
  return api.post("/parkingOwner/forgot-password", action.payload);
};

export function* ForgetPasswordMailCall(
  action: PayloadAction<IForgetPasswordMail>
) {
  try {
    const respons: AxiosResponse<IAPIResponse<null>> = yield call(
      ForgetPasswordMailApi,
      action
    );
    yield put(successForgetPasswordMail(respons.data));
  } catch (error: any) {
    // Extract error message from various possible locations
    let errorMessage = 'Failed to verify email. Please try again.';
    
    if (error?.response?.data) {
      if (error.response.data.response?.error) {
        errorMessage = error.response.data.response.error;
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error;
      } else if (error.response.data.response?.message) {
        errorMessage = error.response.data.response.message;
      } else if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      }
    } else if (error?.message) {
      errorMessage = error.message;
    }
    
    const responseCode = error?.response?.data?.responseCode || 
                        error?.response?.status || 
                        400;
    
    yield put(failureForgetPasswordMail({
      responseCode: responseCode,
      responseMessage: 'failed',
      response: { error: errorMessage }
    }));
  }
}
